import React from 'react';

import AppTheme from "../AppTheme";

import './chartstyles.css'

import * as d3 from '../../../d3/d3.v7';
import chroma from "../../../d3/chroma";
import colorbrewer2 from '../../../d3/colorbrewer2';

class ChordDiagram extends React.Component {

    constructor(props) {
        super(props);
        this.divRef = React.createRef();
        this.divRefTooltip = React.createRef();
    }

    componentDidMount() {
        this.updateUI();
    }

    componentDidUpdate() {
        this.updateUI();
    }

    updateUI() {
        if (!this.props.data) return;

        const width = this.props.width;
        const height = this.props.height;

        const nodes = this.props.data.nodes;
        const links = this.props.data.links;
        //console.log(this.props.data);

        const refIdTooltip = this.divRefTooltip.current;
        d3.select(refIdTooltip).select("div").remove();
        var tooltip = d3.select(refIdTooltip).append("tooltip").append("div");

        const refId = this.divRef.current;
        d3.select(refId).select("svg").remove();
        var svg = d3.select(refId)
            .append("svg")
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", "translate(" + (width / 2) + "," + (height / 2) + ")")

        const outerRadius = Math.min(width, height) / 2 - 75;
        const innerRadius = outerRadius - 25;

        var totalCounts = 0;
        var matrix = [], names = [], counts = [];
        for (var i = 0; i < nodes.length; i++) {
            names.push(nodes[i].name);
            counts.push(nodes[i].value)
            totalCounts += nodes[i].value;
            matrix[i] = [];
            for (var j = 0; j < nodes.length; j++) {
                matrix[i][j] = 0;
            }
        }
        links.forEach((l) => {
            matrix[l.source][l.target] = l.value;
        });

        let max = null, min = null;
        matrix.forEach((r) => {
            const rmax = Math.max.apply(null, r);
            const rmin = Math.min.apply(null, r);
            max = max ? Math.max(max, rmax) : rmax;
            min = min ? Math.min(min, rmin) : rmin;
        });

        //disperse self refs while keeping chord groups %
        let maxPct = 0;
        if (true) {
            for (var i = 0; i < nodes.length; i++) {
                const v = matrix[i][i];
                matrix[i][i] = 0;
                for (var j = 0; j < nodes.length; j++) {
                    if (i != j && matrix[i][j] > 0) {
                        matrix[i][j] += v * matrix[i][j] / (counts[i] - v);
                        if (1.0 * matrix[i][j] / counts[i] > maxPct) maxPct = 1.0 * matrix[i][j] / counts[i];
                    }
                }
            }
        }

        var heatmapRed = d3.scaleLinear().domain([0, maxPct]).range([AppTheme.containerWhite, "red"]);

        const max_counts = Math.max.apply(null, counts);

        const color = chroma.scale("Set3").classes(nodes.length);
        const colorScale = d3.scaleLinear().domain([0, nodes.length]).range([0, 1]);

        function colors(i) {
            return "hsl(" + (i * (360 / names.length) % 360) + ",100%,50%)";
        }

        function fade(opacity) {
            return function (e, p) {
                svg.selectAll("path.chord")
                    .filter(function (d) {
                        return d.source?.index != p?.index && d.target?.index != p?.index;
                    })
                    .transition()
                    .style("opacity", opacity);
            };
        }

        function onShow(e, p) {
            showTooltip(e, p);
            fade(0.05)(e, p);
        }

        function onHide(e, p) {
            hideTooltip(e, p);
        }

        var res = d3.chord()
            .padAngle(0.05)
            .sortGroups(d3.descending)
            (matrix);

        const categ = svg.datum(res)
            .append("g")
            .attr("class", "group")
            .selectAll("g")
            .data(function (d) {
                return d.groups;
            })
            .enter()
            .append("g")
            .append("path")
            .attr("id", function (d, i) {
                return "groupc" + d.index;
            })
            .style("fill", (d, i) => color(colorScale(i)).hex())
            .style("fill-opacity", (d, i) => 0.9)
            .style("stroke", (d, i) => "black")
            .style("stroke-opacity", (d, i) => 0.5);

        categ
            .attr("d", d3.arc().innerRadius(innerRadius).outerRadius(outerRadius))
            .on('mouseover', onShow)
            .on('mouseout', onHide)

        /*
        .on('mouseover', (e, d) => {
            chord.classed("faded", function (p) { return p.source.index != d.index && p.target.index != d.index; });
        })
        .on('mouseout', (e, d) => {
            chord.classed("faded", function (p) { return false; });
        })
        */

        function groupTooltip(d, i) {
            let descTo = [], descFrom = [];
            links.forEach((l) => {
                if (l.source == i && matrix[i][l.target] != 0) {
                    const w = matrix[i][l.target] * 100.0 / counts[i];
                    const text = "  " + names[l.target] + ": " + (w < 1 ? "<1" : w.toFixed(0)) + "%\n";
                    descTo.push({weight: w, text: text});
                }
                if (l.target == i && matrix[l.source][i] != 0) {
                    let cnt = 0;
                    for (var j = 0; j < nodes.length; j++) cnt += matrix[j][i]
                    const w = matrix[l.source][i] * 100.0 / cnt; //relative to target inflow
                    //const w = matrix[l.source][i] * 100.0 / counts[l.source]; //relative to source outflow
                    const text = "  " + names[l.source] + ": " + (w < 1 ? "<1" : w.toFixed(0)) + "%\n";
                    descFrom.push({weight: w, text: text});
                }
            });
            descTo.sort(function (a, b) {
                return b.weight - a.weight;
            });
            descFrom.sort(function (a, b) {
                return b.weight - a.weight;
            });

            let linksTo = "", linksFrom = "";
            descTo.forEach((d) => {
                linksTo += d.text;
            });
            descFrom.forEach((d) => {
                linksFrom += d.text;
            });
            return names[i] + " " + (counts[i] * 100.0 / totalCounts).toFixed(0) + "%"
                + (linksTo.length > 0 ? "\n\nTransitions to: \n" + linksTo : "")
                + (linksFrom.length > 0 ? "\nTransitions from: \n" + linksFrom : "");
        }

        function groupTooltipHtml(d, i) {
            let descTo = [], descFrom = [];
            links.forEach((l) => {
                if (l.source == i && matrix[i][l.target] != 0) {
                    const w = matrix[i][l.target] * 100.0 / counts[i];
                    const c = color(colorScale(l.target)).hex();
                    const text = "<tr><td>" + names[l.target] + "</td>"
                        + "<td align='right'>" + (w < 1 ? "<1" : w.toFixed(0)) + "%</td>"
                        + "<td align='left'><svg width='100' height='10' xmlns='http://www.w3.org/2000/svg'><rect width='" + w.toFixed(0) + "' height='10' fill='" + c + "'></svg></td>"
                        + "</tr>";
                    descTo.push({weight: w, text: text});
                }
                if (l.target == i && matrix[l.source][i] != 0) {
                    let cnt = 0;
                    for (var j = 0; j < nodes.length; j++) cnt += matrix[j][i]
                    const w = matrix[l.source][i] * 100.0 / cnt; //relative to target inflow
                    //const w = matrix[l.source][i] * 100.0 / counts[l.source]; //relative to source outflow
                    const c = color(colorScale(l.source)).hex();
                    const text = "<tr><td>" + names[l.source] + "</td>"
                        + "<td align='right'>" + (w < 1 ? "<1" : w.toFixed(0)) + "%</td>"
                        + "<td align='left'><svg width='100' height='10' xmlns='http://www.w3.org/2000/svg'><rect width='" + w.toFixed(0) + "' height='10' fill='" + c + "'></svg></td>"
                        + "</tr>";
                    descFrom.push({weight: w, text: text});
                }
            });
            descTo.sort(function (a, b) {
                return b.weight - a.weight;
            });
            descFrom.sort(function (a, b) {
                return b.weight - a.weight;
            });

            let linksTo = "", linksFrom = "";
            descTo.forEach((d) => {
                linksTo += d.text;
            });
            descFrom.forEach((d) => {
                linksFrom += d.text;
            });
            return "<table class='tabletooltip'>" +
                "<tr><th colspan='2'>" + names[i] + " " + (counts[i] * 100.0 / totalCounts).toFixed(0) + "%</th></tr>" +
                "<tr colsnap='3'>" +
                (linksTo.length > 0 ? "<td align='left' valign='top'><table class='tabletooltip' style='border:0px'><tr><td colspan='3'>Transitions to:</td></tr>" + linksTo + "</table></td>" : "") +
                (linksFrom.length > 0 ? "<td align='left' valign='top'><table class='tabletooltip' style='border:0px'><tr><td colspan='3'>Transitions from:</td></tr>" + linksFrom + "</table></td>" : "") +
                "</tr>"
            "</table>";
        }

        function getParentWithClass(e, names) {
            return e != null ? names.includes(e.className) ? e : getParentWithClass(e.parentNode, names) : null;
        }

        function hasParentWithClass(e, names) {
            return e != null && (names.includes(e.className) || hasParentWithClass(e.parentNode, names));
        }

        function dragged(evt) {
            const e = evt.sourceEvent;
            tooltip
                .style("left", (e.clientX - 140) + "px")
                .style("top", (e.clientY - 200) + "px");
        }

        var dragHandler = d3.drag().on('drag', dragged);

        function showTooltip(e, p) {
            let x = e.clientX - 40; //Math.min(Math.max(e.clientX - 40 - (e.clientX < width / 2 ? 300 : 0) + (e.clientX > width / 2 ? 100 : 0), 1), width - 350);
            let y = e.clientY - 200; //Math.min(Math.max(e.clientY - 200, 1), height - 450);
            tooltip
                .style("left", x + "px")
                .style("top", y + "px")
                .style("position", "absolute")
                .style("display", "inline-block")
                .on('mouseout', (e, p) => hideTooltip(e, p))
                .html(groupTooltipHtml(p, p.index));
            dragHandler(tooltip);
        }

        function hideTooltip(e, p) {
            if (e == null || !hasParentWithClass(e.toElement, [ 'tabletooltip', 'divtooltip' ])) {
                tooltip.style("display", "none");
                fade(1)(e, p);
            }
        }


        //categ
        //    .append("title")
        //    .text((d, i) => groupTooltip(d, i));

        const chord = svg.datum(res)
            .append("g")
            .selectAll("path")
            .data(function(d) { return d; })
            .enter()
            .filter(function(d) {
                return (matrix[d.source.index][d.target.index] != 0 || matrix[d.target.index][d.source.index] != 0)
                        //&& d.source.index != d.target.index && //filter self references. to review if wanted
            })
            .append("path")
            .attr("class", "chord")
            .attr("d", d3.ribbon().radius(innerRadius))
            .style("fill", (d, i) => {
                const val1 = matrix[d.source.index][d.target.index] / max;
                const val2 = matrix[d.target.index][d.source.index] / max;
                const val = (val1 + val2) / 2;
                //var heatmap = d3.scaleLinear().domain([0, 1]).range([AppTheme.containerWhite, colors(d.target.index)]);
                return heatmapRed(val);
            })
            .style("fill-opacity", (d, i) => "0.8")
            .style("stroke", (d, i) => "gray")
            .style("stroke-opacity", (d, i) => 0.25)
            .append("title")
            .text((d, i) => {
                const l1 = matrix[d.source.index][d.target.index] != 0 ? (matrix[d.source.index][d.target.index] * 100.0 / counts[d.source.index]).toFixed(0) + "% from " + names[d.source.index] + " to " + names[d.target.index] : "";
                const l2 = matrix[d.target.index][d.source.index] != 0 ? (matrix[d.target.index][d.source.index] * 100.0 / counts[d.target.index]).toFixed(0) + "% from " + names[d.target.index] + " to " + names[d.source.index] : "";
                return l1 + (l1.length > 0 ? "\n" :"") + l2;
            });

        svg
            .datum(res)
            .append("g")
            .selectAll("text")
            .data(function(d) { return d.groups; })
            .enter()
            .append("text")
            .each(function(d) { d.angle = (d.startAngle + d.endAngle) / 2; })
            .attr("fill", "black")
            .attr("text-anchor", function(d) { return d.angle > Math.PI ? "end" : null; })
            .attr("dy", ".35em")
            .style("font-size", "8pt")
            .style("font-family", "Nunito")
            .style("pointer-events","none")
            .attr("transform", function(d) {
                return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")"
                    + "translate(" + (outerRadius + 10) + ")"
                    + (d.angle > Math.PI ? "rotate(180)" : "");
            })
            .text(function(d,i) { return names[i]; })
            .on('mouseover', onShow)
            .on('mouseout', onHide)
            .append("title")
            .text((d, i) => groupTooltip(d, i));
    }

    render() {
        return <>
            <div ref={this.divRef}></div>
            <div ref={this.divRefTooltip} className={"divtooltip"}></div>
        </>
    }
}

export default ChordDiagram;

